export default "__VITE_ASSET__7289d457__"